<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 掲示板（スレッド）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>掲示板（スレッド）の説明</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/board-thread.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> スレッドボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Filter
        </div>
        <div class="manual-explain">
          掲示板（スレッド）一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、名称、内容
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 掲示板（スレッド）一覧
        </div>
        <div class="manual-explain">
          登録済みの掲示板（スレッド）の一覧が表示されます。<br>
          投稿者は、自身の投稿は青色のアイコン、他人の投稿は赤色のアイコンで表示されます。<br>
          投稿者アイコンをクリックすることで編集画面（自身の投稿）・閲覧画面（他人の投稿）が表示されます。
        </div>
  
      </mat-card-content>
    </mat-card>
  
    </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Bulletin Board (Threads) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Bulletin Board (Threads) Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_board-thread.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Thread Button
          </div>
          <div class="manual-explain">
            Clicking this button displays the add screen.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Filter
          </div>
          <div class="manual-explain">
            Filters the data displayed in the Bulletin Board (Threads) list.<br>
            *The filter applies to Name and Content.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Bulletin Board (Threads) List
          </div>
          <div class="manual-explain">
            Displays a list of registered Bulletin Board (Threads).<br>
            Posts from the user are displayed with a blue icon, while posts from others are displayed with a red icon.<br>
            Clicking a post icon opens the edit screen (for the user's own posts) or the view screen (for others' posts).
          </div>
          </mat-card-content>
      </mat-card>
  </div>
</div>
